// База для socket.io. В деве пусто → относительный путь → Vite-прокси /socket.io.
// В проде (статика на CDN) — абсолютный адрес бэкенда из VITE_WS_URL.
export const WS_BASE = import.meta.env.VITE_WS_URL || '';
